import { Routes } from "@angular/router";
import { AuthGuard } from "./shared/auth-guard/auth.guard";
import { AuthRedirectGuard } from "./shared/auth-guard/auth-redirect.guard";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { fullRoutes } from "./shared/routes/full-routes";
import { contentRoutes } from "./shared/routes/routes";
import { VideoRecorderComponent } from "./component/video-recorder/video-recorder.component";
import { CelebrityComponent } from "./component/celebrity/celebrity.component";
import { ProfilePagesComponent } from "./component/profile-pages/widgets/profile-pages/profile-pages.component";
import { FriendsProfileComponent } from "./component/profile-pages/friends-profile/friends-profile.component";
import { CelebrityByDomainComponent } from "./component/celebrity-by-domain/celebrity-by-domain.component";
import { AdminDashboardComponent } from "./admin/dashboard/admin-dashboard.component";
import { AdminCelebritiesComponent } from "./admin/celebrities/admin-celebrities.component";
import { AdminCelebrityDetailsComponent } from "./admin/celebrities/admin-celebrity-details.component";
import { AdminFansComponent } from "./admin/fans/admin-fans.component";
import { AdminAnalyticsComponent } from "./admin/analytics/admin-analytics.component";
import { AdminCategoriesComponent } from "./admin/categories/admin-categories.component";
import { AdminLogsComponent } from "./admin/logs/admin-logs.component";
import { ChangePasswordComponent } from "./admin/change-password/change-password.component";
import { AuthLoginComponent } from "./auth/auth-login/auth-login.component";
import { AdminGuard } from "./shared/auth-guard/admin.guard";
import { SendmailInfoComponent } from "./component/sendmail-info/sendmail-info.component";
import { ExploreComponent } from "./component/explore/explore.component";
import { ReadVideoComponent } from "./component/read-video/read-video.component";
import { AdminFansDertailsComponent } from "./admin/fans/admin-fans-dertails/admin-fans-dertails.component";
import { PreferencesComponent } from "./component/preferences/preferences.component";
import { TestApiComponent } from "./component/test-api/test-api.component";
import { AdminUsersComponent } from "./admin/users/admin-users.component";
import { AdminRolesComponent } from "./admin/users/roles/admin-roles.component";
import { AdminUsersManagementComponent } from "./admin/users/admin-users-management.component";
import { Style1Component } from "./component/news-feed-layout/style-1/style-1.component";
import { PaymentCallbackComponentComponent } from "./component/payment-callback-component/payment-callback-component.component";
import { PaymentSuccessComponent } from "./component/payment-success/payment-success.component";
import { PaymentFailedComponent } from "./component/payment-failed/payment-failed.component";
import { ComplaintsComponent } from "./admin/complaints/complaints.component";
import { PrivacyPolicyComponent } from "./component/privacy-policy/privacy-policy.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { AuthRegisterComponent } from "./auth/auth-register/auth-register.component";
import { BroadcasterComponent } from "./component/broadcaster/broadcaster.component";
import { ViewerComponent } from "./component/viewer/viewer.component";
import { StreamListComponent } from "./component/stream-list/stream-list.component";
import { StarGuard } from "./shared/auth-guard/star.guard";
import { VideoDemandDetailsComponent } from "./admin/video-demands/video-demand-details/video-demand-details.component";
import { TermsComponent } from "./component/terms/terms.component";
import { CookiesComponent } from "./component/cookies/cookies.component";
import { ChildSafetyComponent } from "./component/child-safety/child-safety.component";

export const routes: Routes = [
  // Route d'accueil publique
  {
    path: "",
    component: ContentComponent,
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./component/news-feed-layout/style-1/style-1.component").then(
            (m) => m.Style1Component,
          ),
      },
      {
        path: "profile",
        loadChildren: () =>
          import("./component/profile-pages/profile-pages.routes"),
      },
      {
        path: "cursom-profile",
        loadChildren: () =>
          import("./component/cursom-profile-pages/profile-pages.routes"),
      },
      {
        path: "favorite",
        loadChildren: () =>
          import("./component/favorite-page/favorite-Page.routes"),
      },
      {
        path: "celebrities/domaines/:id",
        component: CelebrityByDomainComponent,
      },
      ...contentRoutes,
    ],
  },

  // Routes publiques indépendantes
  { path: "payment-callback", component: PaymentCallbackComponentComponent },
  { path: "payment-success", component: PaymentSuccessComponent },
  { path: "payment-failed", component: PaymentFailedComponent },
  { path: "live-payment-success", loadComponent: () => import("./component/live-payment-success/live-payment-success.component").then(m => m.LivePaymentSuccessComponent) },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  {
    path: "contact",
    loadComponent: () =>
      import("./component/contact/contact.component").then(
        (m) => m.ContactComponent,
      ),
  },
  { path: "terms", component: TermsComponent },
  { path: "cookies", component: CookiesComponent },
  { path: "child-safety", component: ChildSafetyComponent },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
  },
  {
    path: "explore",
    component: ExploreComponent,
  },
  {
    path: "sendmail-info",
    component: SendmailInfoComponent,
  },
  {
    path: "verify-email/:token",
    component: ChangePasswordComponent,
  },

  // Route d'authentification
  {
    path: "auth",
    children: [
      {
        path: "login",
        component: AuthLoginComponent,
        canActivate: [AuthRedirectGuard],
      },
      {
        path: "",
        redirectTo: "login",
        pathMatch: "full",
      },
      {
        path: "register",
        component: AuthRegisterComponent,
      },
    ],
  },

  // Route de connexion admin
  {
    path: "admin/login",
    loadComponent: () =>
      import("./admin/admin-login/admin-login.component").then(
        (m) => m.AdminLoginComponent,
      ),
  },

  // Routes protégées avec ContentComponent

  // Autres routes protégées
  {
    path: "upload-video",
    component: VideoRecorderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    component: AdminDashboardComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadComponent: () =>
          import("./admin/dashboard/components/admin-dashboard-content.component").then(
            (m) => m.AdminDashboardContentComponent,
          ),
      },
      {
        path: "video-demands",
        loadComponent: () =>
          import("./admin/video-demands/admin-video-demands.component").then(
            (m) => m.AdminVideoDemandsComponent,
          ),
      },
      {
        path: "video-demands/:id",
        loadComponent: () =>
          import("./admin/video-demands/video-demand-details/video-demand-details.component").then(
            (m) => m.VideoDemandDetailsComponent,
          ),
      },
      {
        path: "publications",
        loadComponent: () =>
          import("./admin/publications/admin-publications.component").then(
            (m) => m.AdminPublicationsComponent,
          ),
      },
      {
        path: "payments",
        loadComponent: () =>
          import("./admin/payments/admin-payments.component").then(
            (m) => m.AdminPaymentsComponent,
          ),
      },
      {
        path: "tarifs",
        loadComponent: () =>
          import("./admin/tarifs/admin-tarifs.component").then(
            (m) => m.AdminTarifsComponent,
          ),
      },
      {
        path: "reports",
        loadComponent: () =>
          import("./admin/reports/admin-reports.component").then(
            (m) => m.AdminReportsComponent,
          ),
      },
      {
        path: "settings",
        loadComponent: () =>
          import("./admin/settings/admin-settings.component").then(
            (m) => m.AdminSettingsComponent,
          ),
      },
      {
        path: "celebrities",
        children: [
          {
            path: "",
            component: AdminCelebritiesComponent,
          },
          {
            path: ":id",
            component: AdminCelebrityDetailsComponent,
          },
        ],
      },
      {
        path: "fans",
        loadComponent: () =>
          import("./admin/fans/admin-fans.component").then(
            (m) => m.AdminFansComponent,
          ),
      },
      {
        path: "fans/:id",
        component: AdminFansDertailsComponent,
      },
      {
        path: "analytics",
        loadComponent: () =>
          import("./admin/analytics/admin-analytics.component").then(
            (m) => m.AdminAnalyticsComponent,
          ),
      },
      {
        path: "categories",
        loadComponent: () =>
          import("./admin/categories/admin-categories.component").then(
            (m) => m.AdminCategoriesComponent,
          ),
      },
      {
        path: "logs",
        loadComponent: () =>
          import("./admin/logs/admin-logs.component").then(
            (m) => m.AdminLogsComponent,
          ),
      },
      {
        path: "users",
        component: AdminUsersManagementComponent,
        children: [
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full",
          },
          {
            path: "list",
            component: AdminUsersComponent,
          },
          {
            path: "roles",
            component: AdminRolesComponent,
          },
        ],
      },
      {
        path: "activity-logs",
        loadComponent: () =>
          import("./admin/activity-logs/admin-activity-logs.component").then(
            (m) => m.AdminActivityLogsComponent,
          ),
      },
      {
        path: "complaints",
        component: ComplaintsComponent,
      },
      {
        path: "contacts",
        loadComponent: () =>
          import("./admin/contacts/admin-contacts.component").then(
            (m) => m.AdminContactsComponent,
          ),
      },
      {
        path: "streams",
        loadComponent: () =>
          import("./admin/streams/admin-streams.component").then(
            (m) => m.AdminStreamsComponent,
          ),
      },
      {
        path: "request-types",
        loadComponent: () =>
          import("./admin/request-types/admin-request-types.component").then(
            (m) => m.AdminRequestTypesComponent,
          ),
      },
      {
        path: "complaint-types",
        loadComponent: () =>
          import("./admin/complaint-types/complaint-types.component").then(
            (m) => m.ComplaintTypesComponent
          ),
      },
    ],
  },
  {
    path: "read-video/:id",
    component: ReadVideoComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "test-api",
    component: TestApiComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "preferences",
    component: PreferencesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "payment-success",
    component: PreferencesComponent,
    canActivate: [AuthGuard],
  },

  // Routes de streaming
  {
    path: "streams",
    component: StreamListComponent,
  },
  {
    path: "stream/:slug/broadcast",
    component: BroadcasterComponent,
    canActivate: [AuthGuard, StarGuard],
  },
  {
    path: "stream/:slug/view",
    component: ViewerComponent,
  },

  // ── Pages publiques de partage (SSR + SEO) ──────────────────────────────
  {
    path: 'share/video/:id',
    loadComponent: () =>
      import('./component/share/share-video-page/share-video-page.component').then(
        (m) => m.ShareVideoPageComponent
      ),
  },
  {
    path: 'share/live/:slug',
    loadComponent: () =>
      import('./component/share/share-live-page/share-live-page.component').then(
        (m) => m.ShareLivePageComponent
      ),
  },

  { path: "**", redirectTo: "" }, // Redirection vers la page d'accueil publique si la route est inconnue
];
